<!-- 右侧导航 -->
<template>
  <div class="rightNavBox" style="display:none;">
    <div class="weiItem1">
      <div class="write rightNavItem flex-c-c-fd">
        <img class="icon" src="../../static/pC/phone-white.png" />
        <div class="rightNavItem-n">咨询热线</div>
      </div>
      <!-- 展示 -->
      <div class="codeBox flex-c-c">
          <div class="flex-c-c" style="width:100%; height: 100%;">{{phone}}</div>
      </div>
    </div>


    <div class="line"></div>

    <div class="weiItem ">
      <div class="rightNavItem flex-c-c-fd">
        <img class="icon"  src="../../static/pC/code-white.png" />
        <div class="rightNavItem-n">二维码</div>
      </div>
      <!-- 展示 -->
      <div class="codeBox ">
          <div class="weiImg flex-c-c"><img :src="qrCode" /></div>
      </div>
    </div>

    <div class="line"></div>
    <div class="rightNavItem flex-c-c-fd" @click="backtop">
      <img class="icon"  src="../../static/pC/code-white.png" />
      <div class="rightNavItem-n">返回顶部</div>
    </div>
  </div>
</template>

<script>
import { apigetSetting, } from '../api/login.js';
export default {
  name: 'RightNav',
  data() {
    return {
      qrCode:'',
      phone:''
    };
  },
  mounted() {
    window.addEventListener('scroll', this.showbtn, true);
    this.getSetting()
  },
  methods: {

    //获取二维码
    getSetting(){
      apigetSetting({}).then(res => {
        if (res.success) {
          this.qrCode = res.data.list.qrCode;
          this.phone = res.data.list.phone;

        } else {
          // this.$message({ message: res.msg, type: 'error' });
        }
      });
    },


    // 显示回到顶部按钮
    showbtn() {
      let that = this;
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      that.scrollTop = scrollTop;
    },

    //返回顶部
    backtop() {
      var timer = setInterval(function() {
        let osTop = document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
        this.isTop = true;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30);
    }
  }
};
</script>

<style scoped>
.rightNavBox{display: block;z-index:100;position: fixed; right: 50px;bottom: 230px;width: 60px; background-color: #345C4E; border: 1px solid #345C4E;border-radius: 6px;}
.rightNavBox .rightNavItem{width: 60px; height: 70px; }
.rightNavBox .rightNavItem .icon{width:23px; height:22px;cursor: pointer;}
.rightNavBox .rightNavItem .rightNavItem-n{margin-top: 5px; color: #FFFFFF; font-size: 12px;}

.line{width: 100%;height: 2px;background: linear-gradient(360deg, #CF825F 0%, #345C4E 0%, #124131 100%);}

.write{cursor: pointer;}

.weiItem1{cursor: pointer;background-image: url("") ; background-repeat: no-repeat;background-size: 60%; background-position:10px 10px}
.weiItem1:hover .codeBox{display: block;}
.weiItem1 .codeBox{display: none; position: absolute;top: 0px;width:200px;height:60px;background:#345C4E;right: 80px;z-index: 1000;border-radius:6px;color: #FFFFFF;}


.weiItem{cursor: pointer;background-image: url("") ; background-repeat: no-repeat;background-size: 60%; background-position:10px 10px}
.weiItem:hover .codeBox{display: block;}
.weiItem .codeBox{display: none;position: absolute;top: 50px;width:145px;height:140px;background:rgba(255,255,255,1);right: 80px;z-index: 1000;border-radius:6px; }
.weiItem .codeBox .weiImg img{width:145px;height:140px;}
</style>



// WEBPACK FOOTER //
// src/components/RightNav.vue